import { FC } from 'react';

type Props = {
	className?: string;
};

const Mail_02_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M5.83594 7.0835L8.28762 8.533C9.71694 9.37808 10.2883 9.37808 11.7176 8.533L14.1693 7.0835'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M1.68111 11.23C1.73559 13.7846 1.76282 15.0619 2.70543 16.0081C3.64804 16.9544 4.95991 16.9873 7.58366 17.0532C9.20072 17.0939 10.8019 17.0939 12.419 17.0532C15.0427 16.9873 16.3546 16.9544 17.2971 16.0081C18.2398 15.0619 18.2671 13.7846 18.3215 11.23C18.3391 10.4086 18.3391 9.59202 18.3215 8.77068C18.2671 6.21604 18.2398 4.93873 17.2971 3.99254C16.3546 3.04635 15.0427 3.01339 12.419 2.94747C10.8019 2.90683 9.20072 2.90683 7.58366 2.94746C4.95991 3.01338 3.64804 3.04633 2.70543 3.99253C1.76282 4.93873 1.73558 6.21603 1.68111 8.7706C1.66359 9.59202 1.66359 10.4086 1.68111 11.23Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Mail_02_Icon;
